import { createStore } from 'zustand/vanilla';

export const gateAuthStore = createStore((set, get) => ({
  token: null,   // string | null
  exp: 0,        // number (ms UNIX)
  set: (t, eMs) => set({ token: t, exp: eMs }),
  clear: () => set({ token: null, exp: 0 }),
  isValid: () => {
    const { token, exp } = get();
    return !!token && Date.now() < (exp || 0) - 5000; // กันล่วงหน้า 5s
  },
}));